import React, { Fragment, useContext } from "react";
import { Trans, useTranslation } from "react-i18next";
import "../../assets/CSS/footer.css";
import { LANGUAGE } from "../../utils/constants";
import UserContext from "../../lib/UserContext";

const Footer = () => {
    const { i18n } = useTranslation();
    const context = useContext(UserContext);

    const isLangSelected = (language) => {
        return language === i18n.language;
    };

    const handleSelection = (value) => {
        context.changeLanguage(value);
    };

    const languages = [
        {
            name: "English",
            value: LANGUAGE.English,
            addSplitter: true,
        },
        {
            name: "Portuguese",
            value: LANGUAGE.Portuguese,
            addSplitter: true,
        },
        {
            name: "Spanish",
            value: LANGUAGE.Spanish,
            addSplitter: true,
        },
        {
            name: "Chinese",
            value: LANGUAGE.Chinese,
        },
    ];

    const renderLanguages = () => {
        return (
            languages &&
            languages.map((lang) => (
                <Fragment key={lang.value}>
                    <span
                        onClick={() => handleSelection(lang.value)}
                        className={`hyperlink ${
                            isLangSelected(lang.value) ? "text-main-gray" : ""
                        }`}
                    >
                        {lang.name}
                    </span>
                    {lang.addSplitter && <span>{" | "}</span>}
                </Fragment>
            ))
        );
    };

    return (
        <>
            <footer className="main-footer" id="main-footer">
                <div>
                    <Trans i18nKey="copyright"> Copyright </Trans> &copy;{" "}
                    {new Date().getFullYear()} NeoSpectra&trade;.{" "}
                    <Trans i18nKey="allRightsReserved">
                        All rights reserved.{" "}
                    </Trans>
                </div>
                <div className="flex items-center">
                    <i className="fas fa-globe mr-1" />
                    <span className="text-xs mr-1">
                        <Trans i18nKey="language"> Language</Trans>:
                    </span>
                    <span>{renderLanguages()}</span>
                </div>
            </footer>
        </>
    );
};

export default Footer;
